// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1wvxy","image":"Header_image__3v9zF","name":"Header_name__1RO-d","info":"Header_info__1QZ3-","infoRow":"Header_infoRow__2dY2A"};